export default (birthdate, outbound, inbound) => {
  const dateBirthdate = new Date(birthdate)
  const dateVerify = new Date(inbound || outbound)
  let ageRange
  let ageTraveler = new Date(dateVerify - dateBirthdate)
  ageTraveler = (Math.abs(ageTraveler.getUTCFullYear() - 1970))

  if (ageTraveler < 2) {
    ageRange = 'infants'
  } else if (ageTraveler < 12) {
    ageRange = 'children'
  } else {
    ageRange = 'adults'
  }
  return ageRange
}
